import gql from 'graphql-tag'

export const QUERY_GET_CAMPAIGNS = gql`
  query Campaigns($mode: [CampaignModeEnum], $measuringDate: [String]) {
    campaigns(mode: $mode, measuringDate: $measuringDate, frequencyType: ONETIME, status: [FINISHED, ACTIVE]) {
      campaigns {
        _id
        mode
        title
        description
        initial_date
        final_date
        message {
          send_date
          send_time
        }
        segments {
          _id
        }
        products {
          sku
        }
        status
        updated_at
      }
    }
  }
`

export const QUERY_GET_GENERIC_CAMPAIGNS = gql`
  query GenericCampaigns(
    $search: String
    $page: Int
    $pageSize: Int
    $sort: [String]
    $sortDirection: [SortDirection]
    $channels: [ChannelEnum]
    $status: [StatusEnum]
    $measuringDate: [String]
    $campaignTypes: [CampaignTypeEnum]
    $disableChannelsForOmniChannel: Boolean
    $frequencyType: CampaignFrequencyTypeEnum
  ) {
    genericCampaigns(
      search: $search
      page: $page
      pageSize: $pageSize
      sort: $sort
      sortDirection: $sortDirection
      channels: $channels
      status: $status
      measuringDate: $measuringDate
      campaignTypes: $campaignTypes
      disableChannelsForOmniChannel: $disableChannelsForOmniChannel
      frequencyType: $frequencyType
    ) {
      records
      page
      campaigns {
        _id
        title
        description
        initial_date
        final_date
        message {
          send_date
          send_time
        }
        segments {
          _id
        }
        products_count
        mode
        status
        updated_at
      }
    }
  }
`

export const QUERY_GET_AGGREGATED_CAMPAIGN_METRICS = gql`
  query AggregatedCampaignMetrics($mode: [CampaignModeEnum], $measuringDate: [String!]!, $campaignTypes: [CampaignTypeEnum], $status: [StatusEnum]) {
    aggregatedCampaignMetrics(mode: $mode, measuringDate: $measuringDate, campaignTypes: $campaignTypes, status: $status) {
      clients_total
      clients_reached
      clients_received_bought
      campaigns_qty
      finished_campaigns_qty
      total_revenue
      campaign_revenue
    }
  }
`
